import React from 'react';
import { useSelector } from "react-redux";
import { Text, View, TouchableWithoutFeedback } from 'react-native';

import { getLangTerm } from "lang";
import { isWeb } from 'utils/platform';

export const MarkerText = ({ title, showStartText, showReviewText, onPress, routeMarkerStyles }) => {

    const lang = useSelector(state => state.settings.lang);
    const reachedDestination = useSelector(state => state.mapData.reachedDestination);
    let showText = true;

    // if (
    //   renderDistance > 10 ||
    //   (longitudeDelta > 0.004023313522353078 && renderDistance > 6)
    // ) {
    //   showText = false;
    // }

    let subHeader = null;

    if (showStartText) {
        // this is the selected route we are currently walking
        if (!reachedDestination) {
            subHeader = <Text style={routeMarkerStyles.subHeader}>{getLangTerm("walk-to-the-starting-point", lang)}</Text>;
        } else  {
            subHeader = <Text style={routeMarkerStyles.subHeader}>{getLangTerm("you-are-here", lang)}</Text>;
        }
        subHeader = <>
        {subHeader}
        <Text style={routeMarkerStyles.subHeader}>{getLangTerm("click-here-to-start", lang)}</Text>
        </>
    }

    if (showReviewText) {
        subHeader = <Text style={routeMarkerStyles.subHeader}>{getLangTerm("please-leave-a-review", lang)}</Text>;
    }

    if (showText) {
        return <View style={ isWeb ? routeMarkerStyles.flyoutContainerWeb : routeMarkerStyles.flyoutContainer}>
            <TouchableWithoutFeedback onPress={onPress}>
                <View style={routeMarkerStyles.textContainer}>
                    <Text style={routeMarkerStyles.header}>{title}</Text>
                    { subHeader }
                </View>
            </TouchableWithoutFeedback>
        </View>
    }
}